import { CarrierAccount } from "@redotech/redo-fulfillment-rate-common/carrier-account";
import * as z from "zod";

export const deleteCarrierAccount = {
  name: "deleteCarrierAccount" as const,
  input: z.object({ carrierAccount: CarrierAccount }),
  output: z.object({
    merchantCarrierAccounts: z.array(CarrierAccount),
    customerCarrierAccounts: z.array(CarrierAccount),
    redoChildCarrierAccounts: z.array(CarrierAccount),
  }),
};
